import { Injectable } from '@angular/core';
import { throwError as observableThrowError, Observable, throwError } from 'rxjs';


import { ServiceBase } from '@app/services/base.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { IdDescricao } from '@app/models/util/id-descricao';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class ConsultasService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  consultar(tipo: string, pesquisa: string = ''): Observable<any> {
    return this.http.get<any>(this.URL_CACHE + `consultas/obterConsulta/?tipo=${tipo}&pesquisa=${pesquisa}`).pipe(
                  catchError(() => 
                    this.http.get<any>(this.URL_API + `consultas/obterConsulta/?tipo=${tipo}&pesquisa=${pesquisa}`).pipe(
                      catchError((error: any) => observableThrowError(error)))));
  }

 retornarParticipante(pesquisa: string): Observable<any> {
  return this.http.get<any>(this.URL_API + `consultas/obterParticipanteDropdown?pesquisa=${pesquisa}`)
    .pipe(
      map(res => {
        return res.dados ?? res;
      })
    );
}

  consultaFiltradaGalhosDR(tipo: 'Receita'|'Despesa') {
    let lista : IdDescricao[] = [];
    // caso extra1 seja o código completo
    lista.filter( (item, index, listaCopia) => {
      // 1.2.1 (pai) 1.2.1.2 (filho)
      String(item.Extra1).startsWith(item.Extra1)
      listaCopia.some(itemCopia => String(itemCopia.Extra1).startsWith(item.Extra1));
    });
  }

  consultarTutelaEmAberto(processoId: number){
    return this.http.get<boolean>(this.URL_API + `financeiro/processo/tutelaProvisoria/verificarTutelaEmAberto/${processoId}`);
  }
}     
